"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _numbers = require("../numbers");

// there is a possibility that font-family name's from guids will start with a letter. this is
// invalid css, unless it is wrapped in quotes.
var wrapFontFamilyInQuotes = function wrapFontFamilyInQuotes(fontFamily) {
  if (!fontFamily) return '';
  var firstChar = fontFamily.charAt(0);
  var isAlreadyWrapped = firstChar === '"' || firstChar === '\'';
  if (isAlreadyWrapped) return fontFamily;
  var hasSpaces = Boolean(fontFamily.match(/\s/gi));
  var hasHyphens = Boolean(fontFamily.match(/-/gi));

  if ((0, _numbers.isNumeric)(firstChar) || hasSpaces || hasHyphens) {
    return "\"".concat(fontFamily, "\"");
  }

  return fontFamily;
};

var _default = wrapFontFamilyInQuotes;
exports["default"] = _default;